import { AxiosResponse } from 'axios'
import { IFilter } from 'types/common'
import { api } from 'API'
import { INotificationWithRelations } from 'interfaces/notification'
import { onMessage } from 'firebase/messaging'
import { messaging, onMessageListener } from 'utils/firebase'

export async function getNotifications(
  filter: IFilter<INotificationWithRelations> = {}
): Promise<INotificationWithRelations[]> {
  const notifications: AxiosResponse = await api.get(`/notifications?filter=${JSON.stringify(filter)}`)
  return notifications.data
}

export async function countNotifications(): Promise<number> {
  const response: AxiosResponse = await api.get(`/users/me/notifications/count-unseen`)
  return response?.data?.count ?? 0
}

export async function seenAllNotifications(): Promise<void> {
  const response = await api.patch(`/users/me/notifications/seen-all`)
  return response.data
}

export async function seenNotification(notificationId: number): Promise<void> {
  if (!notificationId) return
  await api.patch(`/notifications/${notificationId}`, { isSeen: true })
}


